const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'content',
    label: 'Content'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

// Every area starts empty: no menu bar or footer either. The areas stay so a header or footer can be
// added later in the editor (and so the connector can put the site's in).
const defaultProps = {
  slots: [
    { slotId: 'menu-bar', components: [] },
    { slotId: 'content', components: [] },
    { slotId: 'footer', components: [] }
  ],
  templateSettings: {}
};

export default {
  id: 'Blank',
  name: 'Blank page',
  creator: 'Genesis',
  updatedBy: 'Genesis',
  createdAt: 1792022400000,
  updatedAt: 1792022400000,
  slots,
  templateSettings: [],
  defaultProps
};
